import { useMutation } from 'react-query';

export type MarginStrategy =
  | 'REPLACEMENT_COST'
  | 'RETAIL_PRICE'
  | 'RETAIL_DELTA';

export type Priority = 'STANDARD' | 'URGENT';

export type RuleEditRequest = {
  bussinessJustificationId: number;
  customerBranchNumber: string;
  customerCompanyCode: string;
  customerNumber: string;
  effectiveDate: string;
  expirationDate: string;
  id: number;
  marginStrategy: MarginStrategy;
  requestPriority: Priority;
  vendorCompanyCode: string;
  vendorNumber: string;
};

interface RuleEditResponse {
  message: string;
}

export function useRuleEdit() {
  return useMutation<RuleEditResponse, Error, RuleEditRequest>(
    (req: RuleEditRequest) => {
      return Promise.resolve({ message: 'Successfully Submited' });
    }
  );
}
